import React, { useEffect, useState } from "react";
import { fetchMyWorkspaces } from "@/lib/workspaceFetch";
import FxRatesPanel from "../components/FxRatesPanel";

// Same-origin in browser so the session cookie (scoped to the page's host) is sent on every API call.
// Falls back to the build-time env var only for SSR / localhost.
const _API_BASE = (typeof window !== 'undefined' && window.location.hostname !== 'localhost') ? window.location.origin : (process.env.REACT_APP_BACKEND_URL || (typeof window !== 'undefined' ? window.location.origin : ''));
const API = `${_API_BASE}/api`;

export default function FxRatesPage() {
  const [workspaceId, setWorkspaceId] = useState(null);

  useEffect(() => {
    fetchMyWorkspaces()
      .then((rows) => rows?.[0] && setWorkspaceId(rows[0].workspace_id))
      .catch(() => {});
  }, []);

  return (
    <div className="p-6 space-y-4" data-testid="fx-rates-page">
      <h1 className="text-2xl font-bold text-slate-900">FX Rates</h1>
      <FxRatesPanel workspaceId={workspaceId} />
    </div>
  );
}
